// Store resources every route needs before it is shown (keys of resourceStatuses)
export const ROUTE_DEPENDENCIES = {
    dashboard: ['users', 'projects', 'dataList'],
    projects: ['users', 'projects'],
    project: ['users', 'projects', 'dataList'],
    datafolders: ['dataList'],
    datastorage: ['dataList'],
    datapage: ['users', 'dataList'],
    newdata: ['users', 'dataList'],
    friends: ['users'],
    adminUsers: ['users', 'userAccess'],
    adminUser: ['users', 'projects', 'userAccess'],
    adminRoles: ['users'],
    adminLogs: ['users', 'projects', 'logs']
};

// Admin Panel itself needs only users, the rest is loaded per tab inside the panel
export const ADMIN_PANEL_DEPENDENCIES = ['users'];
